import React from 'react'
import FilterListIcon from '@mui/icons-material/FilterList';
import CloseIcon from '@mui/icons-material/Close';
import MobileSubMenuItem from './MobileSubMenuItem';
import { AppBar, Button, Dialog, Divider, IconButton, List, ListItemButton, ListItemText, Slide, Stack, Toolbar, Typography  } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';

type Props = {
  subMenuItems: [string, unknown][] | null
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const MobileSubMenu = (props: Props) => {
  const [open, setOpen] = React.useState(false);

  const {subMenuItems} = props;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Stack 
        onClick={handleClickOpen}
        paddingY='1rem'
        direction="row" 
        spacing={1} 
        textAlign='center' 
        fontFamily='inherit'
        justifyContent='center'
        alignItems='center'
        sx={{backgroundColor: '#1D639E'}}
        >
        <FilterListIcon sx={{color: '#fff', fontSize:'16px'}} />
        <Typography 
          fontWeight='bold'
          fontFamily='inherit' 
          fontSize='inherit'
          color='white'
          component='div'>Filter Resorts</Typography>
      </Stack >
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative', backgroundColor: '#1D639E' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography 
              fontFamily='inherit'
              fontSize='16px'
              sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Filters
            </Typography>
            <Button sx={{fontSize: '16px', fontFamily: 'inherit'}} color="inherit" onClick={handleClose}>
              Apply
            </Button>
          </Toolbar>
        </AppBar>
        <List>
          {
            subMenuItems?.map((menu, index) => {
              const [optionname, arr] = menu
              return (
                <React.Fragment key={index}>
                  <MobileSubMenuItem 
                    title={optionname}
                    index={index}
                    options={arr as string[]} />
                  <Divider />
                </React.Fragment>
              )
            })
          }

        </List>
      </Dialog>
     </React.Fragment>
  )
}

export default MobileSubMenu